import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import MetaTags from "react-meta-tags";
import { useSelector } from "react-redux";
import swal from "sweetalert";

const UserProfile = () => {
  const userCheck = localStorage.getItem("userID");
  const userID = localStorage.getItem("userID");

  const { layoutMode } = useSelector(state => ({
    layoutMode: state.Layout ? state.Layout.layoutMode : "light",
  }));

  const isDark =
    layoutMode === "dark" ||
    (typeof document !== "undefined" &&
      document.body.getAttribute("data-layout-mode") === "dark");
  const theme = isDark ? "dark" : "light";

  // Initial user details state
  const [fname, setfname] = useState("");
  const [lname, setlname] = useState("");
  const [email, setemail] = useState("");
  const [phone, setphone] = useState("");
  const [jobTitle, setjobTitle] = useState("");

  // Snapshot of loaded data to track unsaved changes (dirty) and discard
  const [initialData, setInitialData] = useState({
    fname: "",
    lname: "",
    phone: "",
    jobTitle: "",
  });

  const [detailBtn, setdetailBtn] = useState(true);
  const [savedDetails, setSavedDetails] = useState(false);

  // Passwords state
  const [pass, setpass] = useState("");
  const [newPass, setnewPass] = useState("");
  const [confirmPass, setconfirmPass] = useState("");
  const [detailPassBtn, setdetailPassBtn] = useState(true);
  const [savedPw, setSavedPw] = useState(false);

  // Password visibility toggles
  const [showCurPass, setShowCurPass] = useState(false);
  const [showNewPass, setShowNewPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);

  // Validation error states
  const [fnameError, setfnameError] = useState("");
  const [lnameError, setlnameError] = useState("");
  const [phoneError, setphoneError] = useState("");
  const [currentPassError, setcurrentPassError] = useState("");
  const [newPassError, setnewPassError] = useState("");
  const [confirmPassError, setconfirmPassError] = useState("");

  const name_regx = /^[A-Za-z ]{3,30}$/;
  const phone_regx = /^\d{9,20}$/;
  const password_regx =
    /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{7,15}$/;

  useEffect(() => {
    getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function getUser() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_DEFAULTPATH}user-profile`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userCheck,
          }),
        }
      );
      const data = await response.json();
      if (data && data.user) {
        const newdata = data.user;
        const fn = newdata.FirstName || "";
        const ln = newdata.LastName || "";
        const em = newdata.Email || "";
        const ph = newdata.Phone || "";
        const jt = newdata.JobTitle || "";

        setfname(fn);
        setlname(ln);
        setemail(em);
        setphone(ph);
        setjobTitle(jt);
        setInitialData({
          fname: fn,
          lname: ln,
          phone: ph,
          jobTitle: jt,
        });
        setdetailBtn(true);
      }
    } catch (err) {
      console.error("data retrieval error", err);
    }
  }

  async function updatePersonalDetails() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_DEFAULTPATH}user-profile/updatepersonaldetails`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userID,
            fname: fname.charAt(0).toUpperCase() + fname.slice(1),
            lname: lname.charAt(0).toUpperCase() + lname.slice(1),
            phone,
            jobTitle,
          }),
        }
      );
      const data = await response.json();
      return Boolean(data && data.status);
    } catch (err) {
      console.error("updatePersonalDetails error", err);
      return false;
    }
  }

  async function updatePass() {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_DEFAULTPATH}user-profile/updatepass`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userID,
            pass,
            newPass,
            confirmPass,
          }),
        }
      );
      const data = await response.json();
      return data;
    } catch (err) {
      console.error("updatePass error", err);
      return { status: false, message: "Network or server error" };
    }
  }

  function updatePersonalDetails_sweetAlert() {
    swal({
      title: "Are you sure?",
      text: "Once done, you will update your personal details!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        const success = await updatePersonalDetails();
        if (success) {
          const updatedFname = fname.charAt(0).toUpperCase() + fname.slice(1);
          const updatedLname = lname.charAt(0).toUpperCase() + lname.slice(1);
          setfname(updatedFname);
          setlname(updatedLname);
          setInitialData({
            fname: updatedFname,
            lname: updatedLname,
            phone,
            jobTitle,
          });
          setSavedDetails(true);
          setdetailBtn(true);
          swal("Poof! Your personal details have been updated!", {
            icon: "success",
            buttons: true,
          }).then(reload => {
            if (reload) {
              window.location.reload(false);
            }
          });
        } else {
          swal("Operation has been aborted!");
        }
      } else {
        swal("Operation has been aborted!");
      }
    });
  }

  function updateChangePassword_sweetAlert() {
    swal({
      title: "Are you sure?",
      text: "Once done, you will update your password to new password!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async willDelete => {
      if (willDelete) {
        const response = await updatePass();
        if (response && response.status) {
          setSavedPw(true);
          setpass("");
          setnewPass("");
          setconfirmPass("");
          setcurrentPassError("");
          setnewPassError("");
          setconfirmPassError("");
          setdetailPassBtn(true);
          swal("Poof! Your password has been updated successfully!", {
            icon: "success",
            buttons: true,
          }).then(reload => {
            if (reload) {
              window.location.reload(false);
            }
          });
        } else {
          swal(`${response?.message || "Password update failed"}`);
        }
      } else {
        swal("Operation has been aborted!");
      }
    });
  }

  // Validations
  function checkFnameValidation(val) {
    if (!val || val.trim() === "") {
      setfnameError("Enter first name");
      setdetailBtn(true);
    } else if (name_regx.test(val)) {
      setfnameError("");
      setdetailBtn(false);
    } else if (val.length < 3) {
      setfnameError("Name must contain at least 3 characters");
      setdetailBtn(true);
    } else {
      setfnameError('Name must contain only letters (A-Z)');
      setdetailBtn(true);
    }
  }

  function checklnameValidation(val) {
    if (!val || val.trim() === "") {
      setlnameError("Enter last name");
      setdetailBtn(true);
    } else if (name_regx.test(val)) {
      setlnameError("");
      setdetailBtn(false);
    } else if (val.length < 3) {
      setlnameError("Name must contain at least 3 characters");
      setdetailBtn(true);
    } else {
      setlnameError('Name must contain only letters (A-Z)');
      setdetailBtn(true);
    }
  }

  function checkphoneValidation(val) {
    if (!val || val.trim() === "") {
      setphoneError("Enter mobile number");
      setdetailBtn(true);
    } else if (phone_regx.test(val)) {
      setphoneError("");
      setdetailBtn(false);
    } else if (val.length < 9) {
      setphoneError("Minimum length 9 digits");
      setdetailBtn(true);
    } else {
      setphoneError("Invalid mobile - digits only");
      setdetailBtn(true);
    }
  }

  function checkjobTitleValidation() {
    setdetailBtn(false);
  }

  function checkCurrentPass(Current_Pass) {
    if (!Current_Pass || Current_Pass.trim() === "") {
      setcurrentPassError("Password cannot be empty");
      setdetailPassBtn(true);
    } else if (Current_Pass === newPass && newPass !== "") {
      setnewPassError("Current and New password cannot be the same");
      setdetailPassBtn(false);
    } else if (password_regx.test(Current_Pass)) {
      setcurrentPassError("");
      setdetailPassBtn(false);
    } else {
      setcurrentPassError('Invalid credentials - must contain "A-Z, @, 0-9", 7-15 chars');
      setdetailPassBtn(true);
    }
  }

  function checknewPass(new_Pass) {
    if (new_Pass === pass && pass !== "") {
      setnewPassError("Current and New password cannot be the same");
      setdetailPassBtn(false);
    } else if (!new_Pass || new_Pass.trim() === "") {
      setnewPassError("Password cannot be empty");
      setdetailPassBtn(true);
    } else if (password_regx.test(new_Pass)) {
      if (!confirmPass || new_Pass === confirmPass) {
        setnewPassError("");
        setdetailPassBtn(false);
      } else {
        setnewPassError("New password doesn't match confirm password");
        setdetailPassBtn(true);
      }
    } else {
      setnewPassError('Invalid credentials - must contain "A-Z, @, 0-9", 7-15 chars');
      setdetailPassBtn(true);
    }
  }

  function checkconfirmPass(confirm_new_Pass) {
    if (!confirm_new_Pass || confirm_new_Pass.trim() === "") {
      setconfirmPassError("Password cannot be empty");
      setdetailPassBtn(true);
    } else if (confirm_new_Pass !== newPass) {
      setconfirmPassError("Confirm password doesn't match new password");
      setdetailPassBtn(true);
    } else if (password_regx.test(confirm_new_Pass)) {
      setnewPassError("");
      setconfirmPassError("");
      setdetailPassBtn(false);
    } else {
      setconfirmPassError('Invalid credentials - must contain "A-Z, @, 0-9", 7-15 chars');
      setdetailPassBtn(true);
    }
  }

  // Check if form is dirty
  const isDirty = useMemo(() => {
    return (
      fname !== initialData.fname ||
      lname !== initialData.lname ||
      phone !== initialData.phone ||
      jobTitle !== initialData.jobTitle
    );
  }, [fname, lname, phone, jobTitle, initialData]);

  const handleDiscardDetails = () => {
    setfname(initialData.fname);
    setlname(initialData.lname);
    setphone(initialData.phone);
    setjobTitle(initialData.jobTitle);
    setfnameError("");
    setlnameError("");
    setphoneError("");
    setdetailBtn(true);
    setSavedDetails(false);
  };

  // Initials & display names
  const initials = useMemo(() => {
    const f = (fname || "").trim()[0] || "";
    const l = (lname || "").trim()[0] || "";
    return (f + l).toUpperCase() || "U";
  }, [fname, lname]);

  const fullName = useMemo(() => {
    return `${fname || ""} ${lname || ""}`.trim() || "User Profile";
  }, [fname, lname]);

  const siteDomain = useMemo(() => {
    const d = localStorage.getItem("domain");
    return d ? (d.startsWith("www.") ? d : `www.${d}`) : "";
  }, []);

  // Password strength calculation
  const { pwStrengthScore, pwStrength } = useMemo(() => {
    let sc = 0;
    if (newPass.length >= 8) sc++;
    if (/[A-Z]/.test(newPass) && /[a-z]/.test(newPass)) sc++;
    if (/\d/.test(newPass)) sc++;
    if (/[^A-Za-z0-9]/.test(newPass)) sc++;
    const sLevels = [
      { label: "", color: "var(--fg-tertiary)" },
      { label: "Weak", color: "var(--sev-critical)" },
      { label: "Fair", color: "var(--sev-high)" },
      { label: "Good", color: "var(--sev-medium)" },
      { label: "Strong", color: "var(--status-success)" },
    ];
    const score = Math.max(1, Math.min(4, sc));
    return {
      pwStrengthScore: sc,
      pwStrength: newPass
        ? sLevels[score]
        : { label: "", color: "var(--fg-tertiary)" },
    };
  }, [newPass]);

  const matchOk = Boolean(confirmPass && confirmPass === newPass);
  const pwReady = Boolean(
    pass &&
      newPass &&
      confirmPass &&
      matchOk &&
      newPass !== pass &&
      !currentPassError &&
      !newPassError &&
      !confirmPassError
  );

  const eyeOpenPath =
    "M2 12s3-7 10-7 10 7 10 7-3 7-10 7S2 12 2 12M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6";
  const eyeOffPath =
    "M9.9 4.2A10 10 0 0 1 12 4c7 0 10 8 10 8a13 13 0 0 1-1.7 2.7M6.6 6.6A13 13 0 0 0 2 12s3 8 10 8a9.7 9.7 0 0 0 5.4-1.6M2 2l20 20M14.1 14.1a3 3 0 1 1-4.2-4.2";

  return (
    <React.Fragment>
      <MetaTags>
        <title>Profile | Glogix</title>
      </MetaTags>

      <div className="page-content asm-profile-root" data-theme={theme}>
        <div className="asm-profile-container">

          {/* Header Row: Title & Breadcrumbs */}
          <div className="asm-profile-header-row">
            <h1 className="asm-profile-title">Profile</h1>
            <div className="asm-profile-breadcrumbs">
              <Link to="/dashboard">Dashboard</Link>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="m9 18 6-6-6-6" />
              </svg>
              <span className="asm-breadcrumb-current">My profile</span>
            </div>
          </div>

          {/* Profile Overview Card */}
          <section className="asm-profile-summary-card">
            <span className="asm-profile-avatar">{initials}</span>
            <div className="asm-profile-summary-text">
              <span className="asm-profile-name">{fullName}</span>
              <div className="asm-profile-meta">
                <span className="asm-meta-email">
                  {email || localStorage.getItem("userEmail") || ""}
                </span>
                <span className="asm-meta-dot">·</span>
                <span className="asm-meta-job">
                  {jobTitle || "Member"}
                </span>
              </div>
            </div>
            {siteDomain && (
              <div className="asm-profile-domain-tag">
                <span className="asm-domain-dot" />
                <span>{siteDomain}</span>
              </div>
            )}
          </section>

          {/* Forms Grid (Personal Details & Change Password) */}
          <div className="asm-profile-grid">

            {/* Personal Details Card */}
            <section className="asm-profile-section-card">
              <div className="asm-section-header">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--blue-500)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2M16 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0" />
                </svg>
                <span className="asm-section-title">Personal Details</span>
                {isDirty && (
                  <span className="asm-pill-badge asm-pill-amber">
                    Unsaved changes
                  </span>
                )}
                {!isDirty && savedDetails && (
                  <span className="asm-pill-badge asm-pill-green">
                    Saved
                  </span>
                )}
              </div>

              <div className="asm-section-body">
                <div className="asm-form-grid">
                  {/* First Name */}
                  <div className="asm-form-group">
                    <label htmlFor="asm-fname">First Name</label>
                    <input
                      id="asm-fname"
                      type="text"
                      value={fname}
                      placeholder="Enter First Name"
                      className={`asm-input ${fnameError ? "is-invalid" : ""}`}
                      onChange={e => {
                        setfname(e.target.value);
                        checkFnameValidation(e.target.value);
                        setSavedDetails(false);
                      }}
                    />
                    {fnameError && (
                      <span className="asm-field-error">{fnameError}</span>
                    )}
                  </div>

                  {/* Last Name */}
                  <div className="asm-form-group">
                    <label htmlFor="asm-lname">Last Name</label>
                    <input
                      id="asm-lname"
                      type="text"
                      value={lname}
                      placeholder="Enter Last Name"
                      className={`asm-input ${lnameError ? "is-invalid" : ""}`}
                      onChange={e => {
                        setlname(e.target.value);
                        checklnameValidation(e.target.value);
                        setSavedDetails(false);
                      }}
                    />
                    {lnameError && (
                      <span className="asm-field-error">{lnameError}</span>
                    )}
                  </div>

                  {/* Email (Full width, locked) */}
                  <div className="asm-form-group full-span">
                    <label htmlFor="asm-email">
                      Email
                      <svg
                        width="12"
                        height="12"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="var(--fg-tertiary)"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect x="4" y="11" width="16" height="10" rx="2" />
                        <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                      </svg>
                    </label>
                    <input
                      id="asm-email"
                      type="email"
                      value={email}
                      readOnly
                      disabled
                      className="asm-input locked mono"
                    />
                    <span className="asm-field-help">
                      Email can't be changed
                    </span>
                  </div>

                  {/* Mobile */}
                  <div className="asm-form-group">
                    <label htmlFor="asm-mobile">Mobile</label>
                    <input
                      id="asm-mobile"
                      type="tel"
                      value={phone}
                      placeholder="Enter Mobile"
                      className={`asm-input mono ${phoneError ? "is-invalid" : ""}`}
                      onChange={e => {
                        setphone(e.target.value);
                        checkphoneValidation(e.target.value);
                        setSavedDetails(false);
                      }}
                    />
                    {phoneError && (
                      <span className="asm-field-error">{phoneError}</span>
                    )}
                  </div>

                  {/* Job Title */}
                  <div className="asm-form-group">
                    <label htmlFor="asm-job">Job Title</label>
                    <input
                      id="asm-job"
                      type="text"
                      value={jobTitle}
                      placeholder="Enter Job Title (e.g. Engineer, CTO)"
                      className="asm-input"
                      onChange={e => {
                        setjobTitle(e.target.value);
                        checkjobTitleValidation(e.target.value);
                        setSavedDetails(false);
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="asm-section-footer">
                {isDirty && (
                  <button
                    type="button"
                    className="asm-btn-secondary"
                    onClick={handleDiscardDetails}
                  >
                    Discard
                  </button>
                )}
                <button
                  type="button"
                  className="asm-btn-primary"
                  disabled={
                    detailBtn ||
                    !isDirty ||
                    !!fnameError ||
                    !!lnameError ||
                    !!phoneError ||
                    !fname ||
                    !lname ||
                    !phone
                  }
                  onClick={updatePersonalDetails_sweetAlert}
                >
                  Update Details
                </button>
              </div>
            </section>

            {/* Change Password Card */}
            <section className="asm-profile-section-card">
              <div className="asm-section-header">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="var(--blue-500)"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="4" y="11" width="16" height="10" rx="2" />
                  <path d="M8 11V7a4 4 0 0 1 8 0v4" />
                </svg>
                <span className="asm-section-title">Change Password</span>
                {savedPw && (
                  <span className="asm-pill-badge asm-pill-green">
                    Password updated
                  </span>
                )}
              </div>

              <div className="asm-section-body" style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                {/* Current Password */}
                <div className="asm-form-group">
                  <label htmlFor="asm-curpass">Current Password</label>
                  <div className="asm-input-wrapper">
                    <input
                      id="asm-curpass"
                      type={showCurPass ? "text" : "password"}
                      value={pass}
                      placeholder="Enter Password"
                      className={`asm-input has-toggle ${currentPassError ? "is-invalid" : ""}`}
                      onChange={e => {
                        setpass(e.target.value);
                        checkCurrentPass(e.target.value);
                        setSavedPw(false);
                      }}
                    />
                    <button
                      type="button"
                      className="asm-input-toggle"
                      onClick={() => setShowCurPass(!showCurPass)}
                      aria-label="Toggle password visibility"
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d={showCurPass ? eyeOffPath : eyeOpenPath} />
                      </svg>
                    </button>
                  </div>
                  {currentPassError && (
                    <span className="asm-field-error">{currentPassError}</span>
                  )}
                </div>

                {/* New Password */}
                <div className="asm-form-group">
                  <label htmlFor="asm-newpass">New Password</label>
                  <div className="asm-input-wrapper">
                    <input
                      id="asm-newpass"
                      type={showNewPass ? "text" : "password"}
                      value={newPass}
                      placeholder="Enter Password"
                      className={`asm-input has-toggle ${newPassError ? "is-invalid" : ""}`}
                      onChange={e => {
                        setnewPass(e.target.value);
                        checknewPass(e.target.value);
                        setSavedPw(false);
                      }}
                    />
                    <button
                      type="button"
                      className="asm-input-toggle"
                      onClick={() => setShowNewPass(!showNewPass)}
                      aria-label="Toggle password visibility"
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d={showNewPass ? eyeOffPath : eyeOpenPath} />
                      </svg>
                    </button>
                  </div>
                  {newPass && (
                    <div className="asm-pw-strength-row">
                      <div className="asm-pw-bars">
                        {[1, 2, 3, 4].map(level => (
                          <div
                            key={level}
                            className="asm-pw-bar"
                            style={{
                              background:
                                pwStrengthScore >= level
                                  ? pwStrength.color
                                  : "var(--slate-800)",
                            }}
                          />
                        ))}
                      </div>
                      <span
                        className="asm-pw-strength-label"
                        style={{ color: pwStrength.color }}
                      >
                        {pwStrength.label}
                      </span>
                    </div>
                  )}
                  {newPassError && (
                    <span className="asm-field-error">{newPassError}</span>
                  )}
                </div>

                {/* Confirm New Password */}
                <div className="asm-form-group">
                  <label htmlFor="asm-confpass">Confirm New Password</label>
                  <div className="asm-input-wrapper">
                    <input
                      id="asm-confpass"
                      type={showConfirmPass ? "text" : "password"}
                      value={confirmPass}
                      placeholder="Enter Password"
                      className={`asm-input has-toggle ${confirmPassError || (confirmPass && !matchOk) ? "is-invalid" : ""}`}
                      onChange={e => {
                        setconfirmPass(e.target.value);
                        checkconfirmPass(e.target.value);
                        setSavedPw(false);
                      }}
                    />
                    <button
                      type="button"
                      className="asm-input-toggle"
                      onClick={() => setShowConfirmPass(!showConfirmPass)}
                      aria-label="Toggle password visibility"
                    >
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d={showConfirmPass ? eyeOffPath : eyeOpenPath} />
                      </svg>
                    </button>
                  </div>
                  {confirmPass && (
                    <span
                      className="asm-pw-match-text"
                      style={{
                        color: matchOk
                          ? "var(--green-600)"
                          : "var(--sev-critical)",
                      }}
                    >
                      {matchOk
                        ? "Passwords match"
                        : "Passwords don't match"}
                    </span>
                  )}
                  {confirmPassError && (
                    <span className="asm-field-error">{confirmPassError}</span>
                  )}
                </div>
              </div>

              <div className="asm-section-footer">
                <button
                  type="button"
                  className="asm-btn-primary"
                  disabled={detailPassBtn || !pwReady}
                  onClick={updateChangePassword_sweetAlert}
                >
                  Update Password
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default UserProfile;
